var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"1"}},[_c('span',{class:_vm.spanClass},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }